export default "__VITE_ASSET__CPPolvqf__"